import React, { useContext } from 'react';
import invariant from 'tiny-invariant';

import { UIKind } from 'src/modules/designStudio/components/DesignStudio/UILayer/types';
import type { SlideUpMenuProps } from 'src/modules/designStudio/components/Toolbar/SlideUpMenu';
import { SlideUpMenu } from 'src/modules/designStudio/components/Toolbar/SlideUpMenu';
import { uiLayerContext } from 'src/modules/designStudio/providers';

import type { SlideRightMenuProps } from './SlideRightMenu';
import { SlideRightMenu } from './SlideRightMenu';

type PrunedSlideRightMenuProps = Omit<
  Omit<SlideRightMenuProps, 'closeMenu'>,
  'containerRef'
>;
type SlideSmartMenuProps = SlideUpMenuProps & PrunedSlideRightMenuProps;

const isSlideRightMenuProps = (
  props: SlideRightMenuProps | SlideUpMenuProps,
): props is SlideRightMenuProps => !!props.closeMenu;

const SlideSmartMenu = ({ ...props }: SlideSmartMenuProps) => {
  const { kind: uiKind } = useContext(uiLayerContext);
  if (uiKind === UIKind.LANDSCAPE) {
    if (isSlideRightMenuProps(props)) {
      return <SlideRightMenu {...props} />;
    }

    if (__DEV__) {
      if (!props.closeMenu) {
        invariant(
          false,
          `missing required property 'closeMenu' in ${UIKind.LANDSCAPE} UI`,
        );
      }
    }
  }

  return <SlideUpMenu {...props} />;
};

export { SlideSmartMenu, SlideSmartMenuProps };
